import I18n from "../../i18n";

export default abstract class CtrlBase {

    constructor(protected parentElement:HTMLElement){
    }

    protected renderPage(cb:()=>string,afterLoadCb?:()=>void){
        this.parentElement.innerHTML = "";
        this.parentElement.insertAdjacentHTML("beforeend",cb());
        if(afterLoadCb)afterLoadCb();
        I18n.exec();
    }

    abstract rederInitialPage():void;
}